
import NavBar from '../components/NavBar'
import TabBar from '../components/TabBar'
import Foot from '../components/Foot'
export default {
  components: {
    NavBar,
    TabBar,
    Foot
  },
  // UPDATE STORE PRODUCTS
  async fetch () {
    await this.$store.dispatch('GET_WebsiteData')
  },
  data () {
    return {
      navbar: null
    }
  },
  beforeMount () {
    // window.addEventListener('scroll', this.scrollChecker)
  },
  mounted () {
    this.navbar = this.$el.querySelector('.navbar')
    this.scrollChecker()
    this.$store.commit('INIT_SET_Store')
    // this.$auth.logout()
  },
  updated () {
    this.$fetch()
  },
  methods: {
    scrollChecker () {
      if (window.innerWidth > 400) {
        if (window.pageYOffset > 0) {
          this.navbar.classList.add('navBg')
        } else {
          this.navbar.classList.remove('navBg')
        }
      }
    }
  }
}
